import React, {useEffect, useState, useMemo} from 'react';
import HelixV2BodyTab from '../../../../../Common/CanvasForm/Bodies/BodyTypes/BodySpecial/HelixV2BodyTab';
import {guidanceType, HelixComponentKeys, trialBalanceCategories} from '../../../../../../util/uiconstants';
import Env from '../../../../../../util/env';
import styled from 'styled-components';
import {shallowEqual, useSelector, useDispatch} from 'react-redux';
import {getEngagementIsMest, getTaskDocumentByDocumentId} from '../../../../../../selectors/Ares/selectors';
import {GetHelixProjectFromCanvas} from '../../../../../../actions/HelixIntegration/engagementhelixaction';
import {useSelectedStEntityId} from '../../../../../../util/Ares/customHooks';

export default function StandaloneHelixV2({engagementId, bodyContent, formData, documentId}) {
	const {smartEvidenceSourceId} = useSelector((state) => getTaskDocumentByDocumentId(state, documentId));
	const [helixFilters, setHelixFilters] = useState(null);
	const [isLoading, setIsLoading] = useState(true);

	const dispatch = useDispatch();
	const hasHelixProjects = useSelector((store) => store.configurations?.features?.hasHelixProjects || false);
	const businessUnits = useSelector((state) => state.multiEntity?.stEntityAttributeReadModel?.businessUnits);
	const engagementIsMest = useSelector(getEngagementIsMest);
	const engagementHelixProjects = useSelector((store) => store.engagementHelixProjects, shallowEqual);
	const {ActAreaC, BalCompT, BalAreaC, BalComp3P} = HelixComponentKeys;
	const phaseOneGuidanceTypes = useMemo(() => [ActAreaC, BalCompT, BalAreaC, BalComp3P], []);
	const [currentStEntityId] = useSelectedStEntityId();
	const helixGuidance = useMemo(
		() => bodyContent.guidances.find((guidance) => guidance.guidanceTypeId === guidanceType.HelixComponent),
		[bodyContent.guidances]
	);

	const checkGuidancePhaseOne = useMemo(
		() => () => {
			return phaseOneGuidanceTypes.some((type) => helixGuidance?.guidanceurl?.includes(type));
		},
		[phaseOneGuidanceTypes, helixGuidance]
	);

	useEffect(() => {
		if (helixGuidance && engagementHelixProjects) {
			let filters = Env.getHelixChartFilters(
				engagementHelixProjects,
				helixGuidance.guidanceurl,
				smartEvidenceSourceId?.toString(),
				businessUnits
			);

			if (checkGuidancePhaseOne()) {
				filters?.filters.set('isPhaseOne', true);
			} else {
				filters?.filters.set('isPhaseOne', false);
			}

			setHelixFilters(filters);
			setIsLoading(false);
		}
	}, [helixGuidance, engagementHelixProjects, smartEvidenceSourceId, businessUnits, checkGuidancePhaseOne]);

	const getShowEyHelixSetup = useMemo(() => {
		let showSetup = false;
		if (!helixFilters) {
			showSetup = true;
		}
		if (engagementIsMest && !businessUnits) {
			showSetup = true;
		}
		return showSetup;
	}, [helixFilters, engagementIsMest, businessUnits]);

	useEffect(() => {
		const query = {
			trialBalanceTypeCategory: trialBalanceCategories.Planning,
			IncludeConnections: true
		};

		if (currentStEntityId) {
			query.multiEntityIds = currentStEntityId;
		}

		dispatch(GetHelixProjectFromCanvas(engagementId, query));
	}, []);

	return (
		<StyledHelixV2>
			{!isLoading && (
				<HelixV2BodyTab
					engagementId={engagementId}
					showEYHelixSetup={getShowEyHelixSetup}
					isHelixEnabled={hasHelixProjects}
					helixFilters={helixFilters}
					bodyId={bodyContent?.id}
				/>
			)}
		</StyledHelixV2>
	);
}

const StyledHelixV2 = styled.section`
	display: flex;
	height: 100%;
	width: 100%;
	.helix-viewer {
		border: none;
		hx-viewer {
			.pbi-report-container,
			.hx-viewer-container {
				background: transparent;
				height: 80vh;
				@media only screen and (min-width: 768px) and (max-width: 1280px) {
					height: 70vh;
				}
				iframe {
					border: none;
				}
			}
		}
	}
`;
